// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1961":"2b2122c8","7206":"478d2933"}[chunkId] + ".chunk.css";
};